import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AuthenticationService } from '~shared/services/authentication.service';

export const userIsLoggedInGuard: CanActivateFn = () => {
  const authenticationService = inject(AuthenticationService);
  const router = inject(Router);
  if (authenticationService.isLoggedIn()) {
    return true;
  } else {
    authenticationService.clearStoredTokens();
    return router.createUrlTree(['/login']);
  }
};
